import React, { ReactElement, useContext, useMemo, createContext } from "react";

export type DesignSystemVariant = "next" | "enterprise";

export type DesignSystemTheme = "default";

const DEFAULT_CONTEXT: ThemeContextValue = {
  inputVariant: "next",
  buttonVariant: "next",
  textVariant: "next",
  theme: "default", // we dont have any themes yet e.g. darkmode
};

interface ThemeContextValue {
  inputVariant: DesignSystemVariant;
  buttonVariant: DesignSystemVariant;
  textVariant?: DesignSystemVariant;
  modalVariant?: DesignSystemVariant;
  theme: DesignSystemTheme;
}

interface ThemeProviderProps extends ThemeContextValue {
  children: ReactElement | ReactElement[];
}

const ThemeContext = createContext<ThemeContextValue>(DEFAULT_CONTEXT);

export default function ThemeProvider({
  children,
  inputVariant,
  buttonVariant,
  theme,
  textVariant = "next",
  modalVariant = "next",
}: ThemeProviderProps) {
  const themeContextValue = useMemo(
    () => ({ buttonVariant, inputVariant, theme, textVariant, modalVariant }),
    [buttonVariant, inputVariant, theme, textVariant, modalVariant]
  );
  return (
    <ThemeContext.Provider value={themeContextValue}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useThemeContext() {
  const context = useContext(ThemeContext);
  if (!context) {
    console.warn("No provider for theme context found");
    return DEFAULT_CONTEXT;
  }
  return context;
}
